import axios from 'axios'
import { COMPLAN, WEBSHAREPAGE } from "./config.js";
import qs from 'qs'

axios.defaults.withCredentials = true

export const fanyiComplain = (data) => {
  return new Promise((resolve, reject) => {
    axios.post(COMPLAN, qs.stringify(data), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then((res) => {
      resolve(res.data)
    }).catch((err) => {
      reject(err)
    })
  })
}

export const webTransPage = (data) => {
  let url = `${WEBSHAREPAGE}?to=${data.to}&url=${data.url}&type=${data.type}&product=${data.product}&salt=${data.salt}&sign=${data.sign}`
  return new Promise((resolve, reject) => {
    axios.post(url).then((res) => {
      resolve(res.data)
    }).catch((err) => {
      reject(err)
    })
  })
}
